module.exports = __webpack_public_path__ + "img/묻고더블로가.540aab65.png";